import avisSVG from "@/assets/image-avis.png";
import BoutonSquelette from "@/components/BoutonSquelette/BoutonSquelette";
import LienExterne from "@/components/Lien/LienExterne/LienExterne";
import { environnement } from "@/configuration/environnement";
import { i18n } from "@/configuration/i18n/i18n";
import { Card } from "@codegouvfr/react-dsfr/Card";

const CarteAvisÉlève = () => {
  if (!environnement.VITE_LAISSER_AVIS_URL) return null;

  return (
    <Card
      desc={i18n.ÉLÈVE.TABLEAU_DE_BORD.CARTES.AVIS.SOUS_TITRE}
      footer={
        <LienExterne
          ariaLabel={i18n.ÉLÈVE.TABLEAU_DE_BORD.CARTES.AVIS.BOUTON}
          href={environnement.VITE_LAISSER_AVIS_URL}
          variante="neutre"
        >
          <BoutonSquelette
            ariaHidden={false}
            icône={{ position: "droite", classe: "fr-icon-arrow-right-line" }}
            taille="grand"
          >
            {i18n.ÉLÈVE.TABLEAU_DE_BORD.CARTES.AVIS.BOUTON}
          </BoutonSquelette>
        </LienExterne>
      }
      horizontal
      id="eleve-avis"
      imageAlt=""
      imageUrl={avisSVG}
      ratio="33/66"
      size="large"
      title={i18n.ÉLÈVE.TABLEAU_DE_BORD.CARTES.AVIS.TITRE}
    />
  );
};

export default CarteAvisÉlève;
